<div class="bottom-nav-wrapper">
  <nav class="bottom-nav" aria-label="Navigation principale mobile">
    <a
      *ngFor="let item of navItems"
      class="bottom-nav__item"
      [class.bottom-nav__item--active]="isActive(item.route)"
      [routerLink]="item.route"
      [attr.aria-label]="item.ariaLabel"
    >
      <mat-icon
        class="bottom-nav__icon"
        [matBadge]="getBadgeCount(item.route)"
        matBadgeColor="warn"
        matBadgeSize="small"
        [matBadgeHidden]="isBadgeHidden(item.route)"
      >{{ item.icon }}</mat-icon>
      <span class="bottom-nav__label">{{ item.label }}</span>
    </a>
  </nav>
</div>
